import { CurrencyEnum } from '@systemeio/types'
import { cents } from '@systemeio/util'
import { AffiliateSumType } from 'modules/affiliate/types/affiliate-statistic-interface'

export const getChartValue = (chartValue: AffiliateSumType[CurrencyEnum]) =>
  chartValue ? chartValue : cents(0)
